import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { ReactNode } from "react";
import IconButton from "@mui/material/IconButton";
import IconClose from "../svg/IconClose";

export interface TermsModalProps {
  open: boolean;
  onClose: () => void;
  displayedData: ReactNode;
}

function TermsModal({ open, onClose, displayedData }: TermsModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: "#fffbf6",
          overflow: "hidden",
          position: "relative",
        },
      }}
    >
      <IconButton
        className="close-button"
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 20,
          top: 20,
          zIndex: 1000,
        }}
      >
      <IconClose />
      </IconButton>
      <div className="markdown-parent-container">
        <DialogContent>{displayedData}</DialogContent>
      </div>
    </Dialog>
  );
}

export default TermsModal;
